import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Company } from 'src/app/domains/companies/models/company.model';
import { ConnectionEquipmentInfo } from 'src/app/domains/connectivity/models/connectivity.model';
import { ConnectivityService } from 'src/app/domains/connectivity/services/connectivity.service';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-add-connectivity-equipment-popup',
  templateUrl: './add-connectivity-equipment-popup.component.html',
  styleUrls: ['./add-connectivity-equipment-popup.component.scss']
})
export class AddConnectivityEquipmentPopupComponent implements OnInit {
  public company: Company;
  public connectionId: number;
  public loading: boolean = false;
  @Output() onCreateEquipment: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private activeModal: NgbActiveModal,
    private connectivityService: ConnectivityService,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {
  }

  createEquipment(event: ConnectionEquipmentInfo) {
    this.loading = true;
    this.connectivityService.createEquipment(event)
      .subscribe(
        (response: ConnectionEquipmentInfo) => {
          this.onCreateEquipment.emit();
          this.loading = false;
          this.close();
        },
        () => {
          this.loading = false;
          this.close();
        });
  }

  close() {
    this.activeModal.close();
  }
}
